export default __webpack_public_path__ + "locales/es/SMTPSettings.json?hash=14e0ad3288db84eb0aa779d42e77fbd8";